import React from "react";
import "./Video.css";
import video from '../../assets/videos/Agricolart-spot.mp4';

const Video = () => {
    return (
        <section className="video-section">
            <div className="video">
                <video src={video} autoPlay muted playsInline>
                </video>
            </div>
        </section>
    );
}

export default Video;
